"use client"

import { AppChannel } from "@/config/channel"
import { useConfigParams } from "@/hooks/use-config-params"
import { useEffect } from "react"

export function SeapScriptInjection() {
  const { channel } = useConfigParams()

  useEffect(() => {
    if (channel !== AppChannel.PortaleWebFullResponsiveWwwSisalIt) return

    const script = document.createElement("script")
    script.defer = true
    script.src = window.APP_SEAP_URL

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [channel])

  return null
}
